import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=067c4798&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c4798",
  null
  
)

export default component.exports